export const formatSigned = (value: number) => (value >= 0 ? `+ ${value}` : `− ${-value}`);
